import { resolveSupportedLocale } from '@runtime/core/i18n/localeConfig'
import { useAppStore } from '@runtime/core/store/appStore'

// Apply the arrival language before the router captures the initial URL.
export function applyRequestedLocale() {
  const url = new URL(window.location.href)
  const requested =
    resolveSupportedLocale(url.searchParams.get('lang')) ||
    resolveSupportedLocale(url.searchParams.get('locale'))
  if (!requested) return

  useAppStore.getState().setLocale(requested)
  url.searchParams.delete('lang')
  url.searchParams.delete('locale')
  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`,
  )
}
